import { ReactNode } from 'react';
import { CardProps } from './Card.types';

export function Card({
  title,
  description,
  children,
  className = '',
  headerClassName = '',
  titleClassName = '',
  descriptionClassName = '',
  required,
  ...props
}: CardProps) {
  const baseCardClasses = 'bg-navy-800/50 border border-navy-600/50 rounded-xl p-3 sm:p-4';
  const combinedClasses = `${baseCardClasses} ${className}`.trim();
  const combinedHeaderClasses = `mb-3 ${headerClassName}`.trim();
  const combinedTitleClasses = `text-sm sm:text-base font-semibold text-white ${titleClassName}`.trim();
  const combinedDescriptionClasses = `mt-1 text-xs sm:text-sm leading-5 text-gray-400 ${descriptionClassName}`.trim();

  const isReactElement = title && typeof title === 'object';

  return (
    <div {...props} className={combinedClasses}>
      {(title || description) && (
        <div className={combinedHeaderClasses}>
          {title && (
            <>
              {isReactElement ? (
                <div className={combinedTitleClasses}>
                  {title}
                  {required && <span className="text-red-400 ml-0.5">*</span>}
                </div>
              ) : (
                <h3 className={combinedTitleClasses}>
                  {title}
                  {required && <span className="text-red-400 ml-0.5">*</span>}
                </h3>
              )}
            </>
          )}
          {description && (
            <p className={combinedDescriptionClasses}>{description}</p>
          )}
        </div>
      )}
      {children}
    </div>
  );
}

